import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import trainTime from '../../lib/TrainTime';
import { translate as t } from '../../lib/I18n';
import { diffDuration, durationString } from '../../helpers/Durations';

function Duration ({ startTime, endTime, className }) {
    const duration = diffDuration(startTime, endTime);
    return (
        <time className={ classnames('duration', className) }
            dateTime={ t('time.duration', duration) }
            title={durationString(duration, {type: 'long'})}
        >
            { durationString(duration) }
        </time>
    );
}


Duration.propTypes = {
    className: PropTypes.string,
    startTime: PropTypes.object,
    endTime: PropTypes.object
};

Duration.defaultProps = {
    startTime: trainTime(),
    endTime: trainTime()
};


export default Duration;



// WEBPACK FOOTER //
// ./src/components/general/Duration.js